import React, { useState, useEffect } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";
import { toast } from "react-toastify";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import { apiRoutes } from "../../../../routes/api/apiRoutes";
import { useNavigate, useParams } from "react-router-dom";
import { uiRoutes } from "../../../../routes/ui/uiRoutes";

const EditHomeBanner = () => {
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const [isShow, setShow] = useState();
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSet, isSetData] = useState(false);

  const [data, setData] = useState({
    title1: "",
    title2: "",
    redirect_url: "/services",
    description: "",
    image_url: "",
    image: "",
    // _method: "PUT",
  });

  useEffect(() => {
    callAPI("get", apiRoutes.admin.homeBanner + "/" + id);
  }, []);

  if (responce?.data && !isSet) {
    setData({ ...responce.data });
    isSetData(true);
  }

  const onClickSubmit = (e) => {
    e.preventDefault(); // ⛔ Prevent default form submission

    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });
    formData.append("_method", "PUT");
    if (data.image) {
      formData.append("image", data.image);
    } // Append the file directly

    callAPI("post", apiRoutes.admin.homeBanner + "/" + id, formData);
  };


  useEffect(() => {
    if (responce?.data && statusCode === 202) {
      toast.success("✅ Thank you! Home Banner Update Successfully", {
        autoClose: 2000,
      });
      setShow(true);

      setTimeout(() => {
        navigate(uiRoutes.admin.homeBanner.list);
      }, 2000); // Matches toast duration
    }
  }, [responce, statusCode]);


  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container">
          <PageHeading
            title="Add Home Banner Input"
            subTitle="Fill out form for adding detail to Home Banner."
          />
          <div className="card p-4 shadow-sm mt-3">
            <form onSubmit={onClickSubmit}>
              <div className="row">
                {/* Row 1: Banner Heading */}
                <div className="col-12 mb-3">
                  <label htmlFor="name" className="form-label">
                    Title 1
                  </label>
                  <input
                    value={data?.title1}
                    onChange={(e) =>
                      setData({
                        ...data,
                        title1: e.target.value,
                      })
                    }
                    type="text"
                    className="form-control py-2"
                    id="Add_Testimonial_name"
                    placeholder="Enter Banner Heading"
                  />
                  <span className="val-message">
                    {error?.message === "ValidationError" &&
                      error?.data?.title1}{" "}
                  </span>
                </div>

                <div className="col-12 mb-3">
                  <label htmlFor="name" className="form-label">
                    Title 2
                  </label>
                  <input
                    value={data?.title2}
                    onChange={(e) =>
                      setData({
                        ...data,
                        title2: e.target.value,
                      })
                    }
                    type="text"
                    className="form-control py-2"
                    id="Add_Testimonial_name"
                    placeholder="Enter Banner Heading"
                  />
                  <span className="val-message">
                    {error?.message === "ValidationError" &&
                      error?.data?.title2}{" "}
                  </span>
                </div>
                {/* Row 2: Banner Detail */}
                <div className="col-12 mb-4">
                  <label htmlFor="note" className="form-label">
                    Description
                  </label>
                  <textarea
                    onChange={(e) =>
                      setData({
                        ...data,
                        description: e.target.value, // updating 'description'
                      })
                    }
                    className="form-control py-2"
                    id="Add_Testimonial_Description"
                    rows="4"
                    placeholder="Enter Banner Detail"
                    value={data?.description} // ✅ use 'description' instead of 'title1'
                  ></textarea>
                  <span className="val-message text-danger">
                    {error?.message === "ValidationError" && error?.data?.description}
                  </span>
                </div>

                {/* Row 3: Banner Image */}
                <div className="col-12 mb-3">
                  <label htmlFor="name" className="form-label">
                    Image
                  </label>
                  <input
                    onChange={(e) =>
                      setData({
                        ...data,
                        image: e.target.files[0],
                      })
                    }
                    type="file"
                    className="form-control py-2"
                    id="Home_Banner_img"
                  />
                  <span className="val-message">
                    {error?.message === "ValidationError" && error?.data?.image}{" "}
                  </span>
                  <br />
                  <img src={data?.image_url} height={200} width={200} />
                </div>
              </div>

              <button type="submit" className="btn btn-primary mt-3">
                Submit
              </button>
            </form>
          </div>
        </div>
      }
    />
  );
};

export default EditHomeBanner;
